module.exports = ".breadcrumb {\r\n  background: none;\r\n  font-family: 'Roboto', sans-serif !important;\r\n}\r\n\r\n  .breadcrumb a {\r\n    color: cornflowerblue;\r\n  }\r\n\r\n  .breadcrumb a.link-effect:before {\r\n      background-color: cornflowerblue;\r\n    }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/page-header-breadcrumb/page-header-breadcrumb.component.css
// module id = ./src/app/shared/components/page-header-breadcrumb/page-header-breadcrumb.component.css
// module chunks = main